import type { SxProps, Theme } from '@mui/material';

export const tableContainer: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  overflowX: 'auto',
});

export const headerCell: SxProps<Theme> = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  fontSize: '13px',
  fontWeight: 600,
  textTransform: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  whiteSpace: 'nowrap',
});

export const curatedRow: SxProps<Theme> = (theme: Theme) => ({
  '&:hover .track-artwork': { opacity: 0.7 },
  '&:hover .play-button': { opacity: 1 },
  borderBottom: `1px solid ${theme.palette.divider}`,
});

export const thumbnailContainer: SxProps<Theme> = {
  position: 'relative',
  width: 48,
  height: 48,
  borderRadius: '4px',
  overflow: 'hidden',
  flexShrink: 0,
};

export const playButton: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  opacity: 0,
  transition: 'opacity 120ms ease-in-out',
};

export const playButtonActive: SxProps<Theme> = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  opacity: 1,
};

/**
 * "New" overline label shown above the track title for recently-added tracks.
 * Green comes from the success theme token (adapts light/dark). Tight
 * line-height so it stacks snugly above the title.
 */
export const newLabel: SxProps<Theme> = (theme: Theme) => ({
  display: 'block',
  color: theme.palette.success.main,
  fontSize: '12px',
  lineHeight: 1.5,
});

export const numericCell: SxProps<Theme> = {
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

/**
 * Max widths that bound the free-text columns so long titles/albums truncate
 * with an ellipsis (via TruncatedText) instead of wrapping and breaking row
 * height uniformity. Values are caps — short text still renders at its natural
 * width.
 */
export const titleArtistText: SxProps<Theme> = {
  maxWidth: 175,
};

export const albumText: SxProps<Theme> = {
  maxWidth: 150,
};

export const actionsCell: SxProps<Theme> = {
  whiteSpace: 'nowrap',
};
